<template>
    <div class="uploadItem" :style="styles" :class="{ 'upload-dis': disabled }">
        <div class="uploadItem_top_con" @click.stop.prevent="!disabled && changeChecked($event)" v-if="item.url">
            <slot name="uploadItem_top"></slot>
            <div class="uploadItem_mask" v-if="item.checked"></div>
            <div class="checkBox">
                <el-checkbox v-model="item.checked" :disabled="disabled"></el-checkbox>
            </div>
        </div>
        <div class="uploadItem_top_con uploadItem_top_con1" v-else>
            <slot name="uploadItem_top"></slot>
        </div>
        <div class="uploadItem_bot">
            <div class="uploadItem_size" v-if="item.url">{{item.material_size}}</div>
            <el-tooltip :content="item.name" placement="top" :disabled="item.name | isDisabled((parseInt(width) - 16) * 2)">
                <div class="uploadItem_name" @[clickType]="editName(item.name)">
                    <p ref="name">{{item.name}}</p>
                </div>
            </el-tooltip>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UploadItem',
    props: {
        item: {
            type:Object,
            default: () => {}
        },
        width: {
            type: [Number, String],
            default: '240px'
        },
        height: {
            type: [Number, String],
            default: '185px'
        },
        isUploadFlag: {
            type: Boolean,
            default: true
        },
        disabledFun: {
            type: Function,
            default: () => false
        }
    },
    computed: {
        styles() {
            return {
                'width': this.width,
                'height': this.height
            }
        },
        clickType() {
            return this.isUploadFlag? 'click': 'none'
        },
        disabled() {
            return this.disabledFun(this.item)
        }
    },
    methods: {
        changeChecked(e) {
            this.$emit('changeChecked', e)
        },
        editName() {
           this.$emit('editName')
        }
    },
    filters: {
        isDisabled(value, w) {
            let span = document.createElement('span')
            span.innerHTML = value
            span.style = 'font-size: 12px;color: #6a6c76;line-height: 17px;'
            document.body.appendChild(span)
            let domW = span.offsetWidth
            document.body.removeChild(span)
           return domW > w ? false: true
        }
    }
}
</script>
<style lang="less" scoped>
    .uploadItem {
        border-radius: 4px;
        border: 1px solid #e3e5ee;
        position: relative;
        display: flex;
        flex-direction: column;
        &.upload-dis {
            cursor: not-allowed;
            .uploadItem_top_con, .uploadItem_bot, .uploadItem_bot p {
                cursor: not-allowed;
            }
        }
    }
    .checkBox {
        position: absolute;
        top: 3px;
        left: 8px;
        z-index: 9;
    }
    .uploadItem_bot {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .uploadItem_name {
        padding: 0 8px;
        display: flex;
        p {
            font-size: 12px;
            color: #6a6c76;
            line-height: 17px;
            cursor: pointer;
            overflow: hidden;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            box-sizing: border-box;
            flex: 1;
        }
    }
    .uploadItem_size {
        position: absolute;
        right: 0;
        top: -20px;
        padding: 0 6px;
        height: 20px;
        border-radius: 4px 0 0 0;
        background: rgba(0,0,0,.3);
        color: #fff;
        font-size: 12px;
        line-height: 20px;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 2;
    }
    .uploadItem_top_con {
        position: relative;
        cursor: pointer;
        overflow: hidden;
        height: 0;
        flex: 1 0 auto;
        &.uploadItem_top_con1 {
            cursor: default;
        }
        .uploadItem_mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,.59);
            z-index: 8;
        }
    }
</style>
